import { GET_MANAGE_EXTERNAL_ACCOUNT_SUCCESS } from 'stash/actions/api';

const manage_external_account = (state = {}, action) => {
	switch (action.type) {
		case GET_MANAGE_EXTERNAL_ACCOUNT_SUCCESS:
			return action.response.manageExternalBankAccount || state;
		default:
			return state;
	}
};

export default manage_external_account;
